'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = mapStateToProps;
exports.PointBox = PointBox;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// PointBox

function mapStateToProps(state) {
  return {
    i18n: state.i18n,
    urls: state.urls,
    auth: state.auth
  };
}

function PointBox(_ref) {
  var i18n = _ref.i18n,
      urls = _ref.urls,
      auth = _ref.auth;

  // XXX: currently this is only needed for travel.rakuten.com.tw
  var component = i18n.lang !== 'zh_TW' || !auth || !auth.username ? null : _react2.default.createElement(
    'li',
    { className: 'points' },
    _react2.default.createElement(
      'a',
      { href: urls.external.point, target: '_blank', rel: 'noreferrer noopener', id: 'pointClub' },
      _react2.default.createElement(
        'span',
        { className: 'point' },
        new Intl.NumberFormat(i18n.lang.replace('_', '-')).format(Number(auth.totalPoint))
      ),
      ' \u9EDE\u6578'
    )
  );

  return component;
}

PointBox.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  urls: _react.PropTypes.object.isRequired,
  auth: _react.PropTypes.object
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PointBox);


//////////////////
// WEBPACK FOOTER
// ./src/containers/PointBox.js
// module id = 1240
// module chunks = 0